import { createReducer } from '@reduxjs/toolkit';

import {
  addContentfulCreatives,
  clearContentfulCreatives,
  deleteContentfulCreatives,
  fetchContentfulCreatives,
  saveAllContentfulCreatives,
  updateContentfulCreatives,
} from './actions';
import {
  addIndexToContentfulCreatives,
  storeNewContentfulCreative,
} from './utils';

export default createReducer([], {
  [`${fetchContentfulCreatives}-success`]: (
    state,
    { payload: contentfulCreatives },
  ) => addIndexToContentfulCreatives(contentfulCreatives.contentfulCreatives),

  [addContentfulCreatives]: (state, { payload }) =>
    storeNewContentfulCreative(state, payload),

  [updateContentfulCreatives]: (state, { payload }) =>
    state.map(creative =>
      creative.contentId === payload.contentId
        ? { ...creative, ...payload }
        : creative,
    ),

  [`${saveAllContentfulCreatives}-success`]: (
    state,
    { payload: contentfulCreatives },
  ) => contentfulCreatives.contentfulCreatives,

  [clearContentfulCreatives]: () => [],

  [`${deleteContentfulCreatives}-success`]: (state, { meta: { id } }) =>
    state.filter(creative => creative.contentId !== id),
});
